// extracted by mini-css-extract-plugin
export var panel = "styles-module--panel--6371d";
export var scroll = "styles-module--scroll--37227";
export var title = "styles-module--title--b5e51";